import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-error-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bo-auth-error-banner.component.html',
  styleUrls: ['./bo-auth-error-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthErrorBannerComponent {
  readonly message = input.required<string>();
  readonly variant = input<'error' | 'info' | 'success'>('error');
}
